export default __webpack_public_path__ + "static/mobile-e2b4f4b18efada18e9b3c83290f93a95.webp";